import { useUserIdentityState } from '@provider/user-identity';
import { useOpgavekompleksetEntry } from '../state/hook.entry.js';
import { header, fragment, date } from './molecule.header.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ResultsHeader() {
  const user = useUserIdentityState(state => state.user);
  const attempt = useOpgavekompleksetEntry({
    select: entry => entry?.data.attempt
  });
  const finishedAt = useOpgavekompleksetEntry({
    select: entry => new Date(entry?.data.endTime ?? 0)
  });
  const isSharedWithTeacher = useOpgavekompleksetEntry({
    select: entry => entry?.envelope.shared
  });
  const showYear = finishedAt?.getFullYear() !== new Date().getFullYear();
  return /*#__PURE__*/jsxs("div", {
    className: header,
    children: [finishedAt && /*#__PURE__*/jsxs("div", {
      className: fragment,
      children: ["Udf\xF8rt:", " ", /*#__PURE__*/jsx("span", {
        className: date,
        children: finishedAt.toLocaleDateString("da-DK", {
          weekday: "long"
        })
      }), " ", "d. ", finishedAt.getDate(), "/", finishedAt.toLocaleDateString("da-DK", {
        month: "numeric"
      }), " ", showYear ? finishedAt.toLocaleDateString("da-DK", {
        year: "numeric"
      }) : "", " ", "- Kl.", " ", finishedAt.toLocaleTimeString("da-DK", {
        minute: "2-digit",
        hour: "2-digit"
      })]
    }), attempt && /*#__PURE__*/jsx("div", {
      className: fragment,
      children: /*#__PURE__*/jsx("b", {
        children: /*#__PURE__*/jsxs("span", {
          children: [attempt, ". fors\xF8g"]
        })
      })
    }), user?.role === "student" && /*#__PURE__*/jsx("div", {
      className: fragment,
      children: isSharedWithTeacher ? "Delt med lærer" : "Ikke delt med lærer"
    })]
  });
}

export { ResultsHeader };
//# sourceMappingURL=molecule.header.js.map
